<template>
  <div class="px-5 py-3 bg-primary-50 border-b border-gray-200 text-sm text-gray-700 flex items-center gap-2 justify-between">
    <div class="flex items-center gap-1.5">
      <slot />
    </div>
    <button
      v-if="clearable"
      type="button"
      class="btn-link items-center"
      :title="clearLabel"
      :aria-label="clearLabel"
      @click="$emit('clear')"
    >
      <font-awesome-icon :icon="['fas', 'times']" class="w-3.5 h-3.5" /> {{ clearLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ContextBar',
  emits: ['clear'],
  props: {
    clearable: {
      type: Boolean,
      default: false
    },
    clearLabel: {
      type: String,
      default: 'Clear'
    }
  }
}
</script>
